export default "__VITE_ASSET__acff97e2__"